import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => {
  return (
    <g>
      <path
        fill={fill}
        d="M17.12 5.71L12.29 0.88C11.7279 0.31723 10.9654 0.000700208 10.17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V15C0 15.7956 0.316071 16.5587 0.87868 17.1213C1.44129 17.6839 2.20435 18 3 18H15C15.7956 18 16.5587 17.6839 17.1213 17.1213C17.6839 16.5587 18 15.7956 18 15V7.83C17.9993 7.03462 17.6828 6.27207 17.12 5.71ZM7 16V14H11V16H7ZM16 15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16H13V13C13 12.7348 12.8946 12.4804 12.7071 12.2929C12.5196 12.1054 12.2652 12 12 12H6C5.73478 12 5.48043 12.1054 5.29289 12.2929C5.10536 12.4804 5 12.7348 5 13V16H3C2.73478 16 2.48043 15.8946 2.29289 15.7071C2.10536 15.5196 2 15.2652 2 15V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H5V7C5 7.26522 5.10536 7.51957 5.29289 7.70711C5.48043 7.89464 5.73478 8 6 8H10C10.2652 8 10.5196 7.89464 10.7071 7.70711C10.8946 7.51957 11 7.26522 11 7C11 6.73478 10.8946 6.48043 10.7071 6.29289C10.5196 6.10536 10.2652 6 10 6H7V2H10.17C10.4348 2.00368 10.6884 2.10727 10.88 2.29L15.71 7.12C15.8027 7.21344 15.876 7.32426 15.9258 7.44609C15.9755 7.56793 16.0008 7.69839 16 7.83V15Z"
      />
    </g>
  );
};

export default Icon;
